import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./header/header";
import Footer from "./Footer";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "./EnrollFormSuccess.css";
import { Modal } from "react-bootstrap";
import { BsEmojiFrown } from "react-icons/bs";
import { format } from "date-fns";
import { ICourseDetails, Referrers, Referrals } from "./EnrollTypes";
import { baseUrl, GetToken, PopulateContext } from "../App";
import { useCourses } from "./Contexts/CoursesContext";
import { generateReceipt } from "./generatePaymentReceipt";
import { ClipLoader } from "react-spinners";
import { useAlert } from "./Contexts/AlertContext";

interface ParsedObject {
  PromoCodeRecipient: boolean,
  inputedPromoCode: string;
  DeadlineValue: number;
  HasDeadline: boolean;
  course: string;
  coursePrice: number;
  email: string;
  firstname: string;
  lastname: string;
  paidPrice: number;
  paymentCurrency: string;
  paymentPercentage: number;
  phone: string;
  sourceOfDiscovery: string;
  status: string;
  paymentType: string;
  scholarshipRecipient: boolean;
  scholarshipUsed: boolean;
  enrolledUserId: string;
  userId: string;
  Referred: boolean;
  AmountPaid: number;
  CourseDiscount: number;
  FullCoursePrice: number;
  AmountCharged:number;
}

const EnrollFormSuccess = () => {
  const {courses, setCoursesContext} = useCourses();
  const navigate: any = useNavigate();
  const [completes, setCompletes] = useState(false);
  const track = useRef(0);
  const { showAlert } = useAlert();

  const handleGoBack = () => {
    navigate("/");
  };
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent(""); 
  };

  // useEffect(() => {
   
  //   stripeHandsonPayment()
  // }, [])


  // const stripeHandsonPayment = async() => {
  //    if (localStorage.getItem("handsonexpFormInfo") &&  localStorage.getItem("handsonexpEmailToUser")
  //          &&   localStorage.getItem("handsonexpEmailToDoyen")) {


  //           try {
  //             let idToken = await GetToken();
  //             const HandsonexperienceFormData = JSON.parse(String(localStorage.getItem("handsonexpFormInfo")))
      
  //          const bodytouser  = JSON.parse(String(localStorage.getItem("handsonexpEmailToUser")))
  //            const bodytodoyen = JSON.parse(String(localStorage.getItem("handsonexpEmailToDoyen")))
  //             await axios
  //               .post(
  //                 `${baseUrl}/handsonexp`,
  //                 HandsonexperienceFormData,
  //                 {
  //                   headers: {
  //                     Authorization: `Bearer ${idToken}`,
  //                   },
  //                 }
  //               )
  //               .then(async(response) => {

  //                   localStorage.removeItem("handsonexpFormInfo")
      
  //                  localStorage.removeItem("handsonexpEmailToUser")
  //                   localStorage.removeItem("handsonexpEmailToDoyen")
      
  //                 const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
  //                       process.env.REACT_APP_SERVICE_KEY, {
  //                       method: "post",
  //                       body: JSON.stringify({
  //                         email: process.env.REACT_APP_SERVICE_EMAIL,
  //                         password: process.env.REACT_APP_SERVICE_PASSWORD,
  //                         returnSecureToken: true,
  //                       }),
  //                       headers: {
  //                         "Content-Type": "application/json",
  //                       },
  //                     });
      
  //                     const userToken = await responseToken.json();
  //                     await axios
  //                     .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
  //                         headers: { Authorization: `Bearer ${userToken.idToken}` },
  //                       }
  //                     )
  //                     .then()
  //                     .catch((e) => {
  //                       console.log("(axios) an error occurred sending mail", e)
  //                     });
      
  //                     await axios
  //                     .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytodoyen, {
  //                         headers: { Authorization: `Bearer ${userToken.idToken}` },
  //                       }
  //                     )
  //                     .then()
  //                     .catch((e) => {
  //                       console.log("(axios) an error occurred sending mail", e)
  //                     });

  //                   showAlert("Data submitted successfully",  "success")
                  
  //                 // toast("Data submitted successfully");
  //               })
  //               .catch((error) => {
  //                 // toast("Something Wrong, check your network");
  //                 showAlert("Something Wrong, check your network",  "error")
  //                 console.log(error);
  //               });

  //           } catch (e) {
  //             console.log(e)
  //           }
          
  //         }
  // }
//   const stripeHandsonPayment = useCallback(async () => {
//   // Check for local storage items
//   const formInfo = localStorage.getItem("handsonexpFormInfo");
//   const emailToUser = localStorage.getItem("handsonexpEmailToUser");
//   const emailToDoyen = localStorage.getItem("handsonexpEmailToDoyen");

//   if (formInfo && emailToUser && emailToDoyen) {
//     try {
//       let idToken = await GetToken();
//       const formData = JSON.parse(formInfo);
//       const bodyToUser = JSON.parse(emailToUser);
//       const bodyToDoyen = JSON.parse(emailToDoyen);

//       // Submit data
//       await axios.post(`${baseUrl}/handsonexp`, formData, {
//         headers: { Authorization: `Bearer ${idToken}` },
//       });

//       // Clear storage only after success
//       localStorage.removeItem("handsonexpFormInfo");
//       localStorage.removeItem("handsonexpEmailToUser");
//       localStorage.removeItem("handsonexpEmailToDoyen");

//       // Get Service Token
//       const authRes = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${process.env.REACT_APP_SERVICE_KEY}`, {
//         method: "post",
//         body: JSON.stringify({
//           email: process.env.REACT_APP_SERVICE_EMAIL,
//           password: process.env.REACT_APP_SERVICE_PASSWORD,
//           returnSecureToken: true,
//         }),
//         headers: { "Content-Type": "application/json" },
//       });

//       const { idToken: serviceToken } = await authRes.json();

//       // Send Emails (Parallelized for speed)
//       const mailUrl = String(process.env.REACT_APP_SERVICE_APP_URL);
//       const mailHeaders = { headers: { Authorization: `Bearer ${serviceToken}` } };

//       await Promise.all([
//         axios.post(mailUrl, bodyToUser, mailHeaders),
//         axios.post(mailUrl, bodyToDoyen, mailHeaders)
//       ]).catch(e => console.error("Email sync failed", e));

//       showAlert("Data submitted successfully", "success");

//     } catch (error) {
//       showAlert("Something went wrong, check your network", "error");
//       console.error(error);
//     }
//   }
// }, [showAlert]); // Add any external variables used inside, like baseUrl

 const stripeHandsonPayment = useCallback(async () => {
     if (localStorage.getItem("handsonexpFormInfo") &&  localStorage.getItem("handsonexpEmailToUser")
           &&   localStorage.getItem("handsonexpEmailToDoyen")) {


            try {
              let idToken = await GetToken();
              const HandsonexperienceFormData = JSON.parse(String(localStorage.getItem("handsonexpFormInfo")))
      
           const bodytouser  = JSON.parse(String(localStorage.getItem("handsonexpEmailToUser")))
             const bodytodoyen = JSON.parse(String(localStorage.getItem("handsonexpEmailToDoyen")))
              await axios
                .post(
                  `${baseUrl}/handsonexp`,
                  HandsonexperienceFormData,
                  {
                    headers: {
                      Authorization: `Bearer ${idToken}`,
                    },
                  }
                )
                .then(async(response) => {

                    localStorage.removeItem("handsonexpFormInfo")
      
                   localStorage.removeItem("handsonexpEmailToUser")
                    localStorage.removeItem("handsonexpEmailToDoyen")
      
                  const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
                        process.env.REACT_APP_SERVICE_KEY, {
                        method: "post",
                        body: JSON.stringify({
                          email: process.env.REACT_APP_SERVICE_EMAIL,
                          password: process.env.REACT_APP_SERVICE_PASSWORD,
                          returnSecureToken: true,
                        }),
                        headers: {
                          "Content-Type": "application/json",
                        },
                      });
      
                      const userToken = await responseToken.json();
                      await axios
                      .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
                          headers: { Authorization: `Bearer ${userToken.idToken}` },
                        }
                      )
                      .then()
                      .catch((e) => {
                        console.log("(axios) an error occurred sending mail", e)
                      });
      
                      await axios
                      .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytodoyen, {
                          headers: { Authorization: `Bearer ${userToken.idToken}` },
                        }
                      )
                      .then()
                      .catch((e) => {
                        console.log("(axios) an error occurred sending mail", e)
                      });

                    showAlert("Data submitted successfully",  "success")
                  
                  // toast("Data submitted successfully");
                })
                .catch((error) => {
                  // toast("Something Wrong, check your network");
                  showAlert("Something Wrong, check your network",  "error")
                  console.log(error);
                });

            } catch (e) {
              console.log(e)
            }
          
          }
}, [showAlert]); // Add any external variables used inside, like baseUrl

useEffect(() => {
  stripeHandsonPayment();
}, [stripeHandsonPayment]);
  const priceSplitter = (number: any) =>
    number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  function uint8ArrayToBase64(uint8Array:any) {
    let binaryString = '';
    for (let i = 0; i < uint8Array.byteLength; i++) {
      binaryString += String.fromCharCode(uint8Array[i]);
    }
    return btoa(binaryString);
  }
  
  const SendEmailToCustomer = useCallback(
    async (
      emaildata: ParsedObject,
      coursedata: ICourseDetails,
      paymentType: string,
      generatedReceipt: any
    ) => {
      const base64Content = uint8ArrayToBase64(generatedReceipt);
      let bodyEmailToCust = {};
      if (paymentType === "secondinstallment") {
        bodyEmailToCust = {
          sender: {
            name: "Doyenify Academy",
            email: "info@doyenify.com",
          },
          to: [
            {
              email: emaildata.email,
            },
          ],
          replyTo:{
            email:"info.doyenify@gmail.com",
          },
          subject: "Your outstanding fees is now paid!",
          htmlContent: `<html><head>
    
                <style>
                    body {
                        background-color:#696969;
                    }
                    .imgtag{
                        justify-content: center;
                        align-items: center;
                        margin-left: 45%;
                    }
                    .welcome {
                        text-align: center;
                        color: #696969;
                    }
            
                    .content {
                        background-color: #ffffff;
                        margin: 15px;
                        padding: 20px;
                    }
                </style>
            </head>
            
            <body>
                <div class="imgtag">
                    <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                </div>
                
                <div class="content">
                    <p>Dear {{params.firstname}},</p> 
                    <p style="margin-bottom: 10px">Thank you for making payment for your outstanding fees of the  {{params.course}} course! We're thrilled you found our trainings exciting enough for the remaining payment</p>
                    <p> Here are details about your second installment payment: </p>

                    <p> Course: {{params.course}} </p>

                    <p>Instructor: {{params.instructor}}</p>

                    <p> Duration: {{params.duration}} </p>

                    <p> Course Venue: Virtual Platform </p>

                    <p> Course Fee: {{params.currencySymbol}}{{params.coursePrice}}  <p>
                    <p> Charged Fee: You have now made a complete payment of {{params.currencySymbol}}{{params.paidPrice}}  <p>
                    <p> You are therefore no longer owing for the {{params.course}} course.

                    <p> The Doyenify Academy team are here to support you every step of the way. If you have any questions, concerns, or need assistance, feel free to reach out to our support team at info.academy@gmail.com or call at +372 5670 4920 or +2347033416581.</p>

                    <p> Once again, Thank you for completing outstanding fees payment! We can't wait to see you excel and achieve your learning goals. </p>

                    <p>Best regards,</p>  
                    <p>DoyenifyAcademy</p>
                </div>
            
                
            </body>
            </html>
                            
                        `,
          params: {
            course: emaildata?.course,
            firstname: emaildata?.firstname,
            coursePrice: priceSplitter(emaildata?.coursePrice),
            paidPrice: priceSplitter(emaildata?.paidPrice),
            duration: coursedata?.Duration,
            instructor: coursedata?.Tutor?.Name,
            currencySymbol: emaildata?.paymentCurrency,
          },
          attachment: [
            {
              name: "Payment Receipt.pdf",
              content: base64Content,
            },
          ],
        };
      } else {
        bodyEmailToCust = {
          sender: {
            name: "Doyenify Academy",
            email: "info@doyenify.com",
          },
          to: [
            {
              email: emaildata.email,
            },
          ],
          replyTo:{
            email:"info.doyenify@gmail.com",
          },
          subject: "Welcome to {{params.course}} - Get ready to learn!",
          htmlContent: `<html><head>
    
              <style>
                  body {
                      background-color:#696969;
                  }
                  .imgtag{
                      justify-content: center;
                      align-items: center;
                      margin-left: 45%;
                  }
                  .welcome {
                      text-align: center;
                      color: #696969;
                  }

                  .content {
                      background-color: #ffffff;
                      margin: 15px;
                      padding: 20px;
                  }
              </style>
          </head>

          <body>
              <div class="imgtag">
                  <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
              </div>
              
              <div class="content">
                  <p>Dear {{params.firstname}},</p> 
                  <p style="margin-bottom: 10px">Welcome to the {{params.course}} course! We're thrilled to have you as a part of our learning community. Congratulations on taking the first step towards expanding your knowledge and skills.</p>
                  <p> Here are details about the course you paid for: </p>

                  <p> Course: {{params.course}} </p>

                  <p>Instructor: {{params.instructor}}</p>

                  <p> Duration: {{params.duration}} </p>

                  <p> Course Venue: Virtual Platform </p>

                  <p> Course Fee: {{params.currencySymbol}}{{params.coursePrice}}  <p>
                  <p> Charged Fee: You were charged a total of {{params.currencySymbol}}{{params.paidPrice}}  <p>

                  <p> {{params.courseDescription}} </p>
                  <p> We're here to support you every step of the way. If you have any questions, concerns, or need assistance, feel free to reach out to our support team at info.academy@gmail.com or call at +372 5670 4920 or +2347033416581.</p>

                  <p> Once again, welcome to the {{params.course}} course! We can't wait to see you excel and achieve your learning goals. </p>

                  <p>Best regards,</p>  
                  <p>DoyenifyAcademy</p>
              </div>

              
          </body>
          </html>
                          
                      `,
          params: {
            course: emaildata?.course,
            firstname: emaildata?.firstname,
            coursePrice: priceSplitter(emaildata?.coursePrice),
            paidPrice: priceSplitter(emaildata?.paidPrice),
            duration: coursedata?.Duration,
            courseDescription: coursedata?.CourseDescription[0],
            instructor: coursedata?.Tutor?.Name,
            currencySymbol: emaildata?.paymentCurrency,
          },
          attachment: [
            {
              name: "Payment Receipt.pdf",
              content: base64Content,
            },
          ],
        };
      }


      const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
        process.env.REACT_APP_SERVICE_KEY, {
        method: "post",
        body: JSON.stringify({
          email: process.env.REACT_APP_SERVICE_EMAIL,
          password: process.env.REACT_APP_SERVICE_PASSWORD,
          returnSecureToken: true,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const userToken = await responseToken.json();
      await axios
      .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyEmailToCust, {
          headers: { Authorization: `Bearer ${userToken.idToken}` },
        }
      )
      .then()
      .catch((e) => {
        console.log("(axios) an error occurred sending mail", e)
      });
     
    },
    []
  );

  const sendEmailtoAdmin = useCallback(
    async (emaildata: ParsedObject, paymentType: string, generatedReceipt:any) => {
      const base64Content = uint8ArrayToBase64(generatedReceipt);
      let bodyEmailToAdmin = {};
      if (paymentType === "secondinstallment") {
        bodyEmailToAdmin = {
          sender: {
            name: "Doyenify Academy Notification",
            email: "info@doyenify.com",
          },
          to: [
            {
              email: "info.doyenify@gmail.com",
            },
          ],
          replyTo:{
            email:"info.doyenify@gmail.com",
          },
          subject:
            "A student just completed payment for the {{params.course}} course",
          htmlContent: `<html><head></head><body>
                                                        <h1>A student just completed their outstanding fees payment</h1>
                                                        <p> Here is the student's details </p>
                                                        <p>Course Name: {{params.course}}</p>
                                                        <p>Course Price: {{params.currencySymbol}}{{params.coursePrice}}  </p>
                                                        <p>Balanced fees of: {{params.currencySymbol}}{{params.paidPrice}}  </p>
                                                        <p>Student's Name: {{params.firstname}}, {{params.lastname}}</p>
                                                        <p>Student's Email: {{params.email}}</p>
                                                        <p>Student's Phone Number: {{params.phone}}</p>
                                                        
                                                        
                                                    </body></html>`,
          params: {
            course: emaildata.course,
            coursePrice: priceSplitter(emaildata?.coursePrice),
            paidPrice: priceSplitter(emaildata?.paidPrice),
            email: emaildata?.email,
            phone: emaildata?.phone,
            firstname: emaildata?.firstname,
            lastname: emaildata?.lastname,
            currencySymbol: emaildata?.paymentCurrency,
          },
        };
      } else {
        bodyEmailToAdmin = {
          sender: {
            name: "Doyenify Academy Notification",
            email: "info@doyenify.com",
          },
          to: [
            {
              email: "info.doyenify@gmail.com",
            },
          ],
          replyTo:{
            email:"info.doyenify@gmail.com",
          },
          subject:
            "A new student successfully paid for {{params.course}} course",
          htmlContent: `<html><head></head><body>
                                                        <h1>A new course enrolment has been made</h1>
                                                        <p> Here is the student's details </p>
                                                        <p>Course Name: {{params.course}}</p>
                                                        <p>Course Price: {{params.currencySymbol}}{{params.coursePrice}}  </p>
                                                        <p>Student paid a total of: {{params.currencySymbol}}{{params.paidPrice}}  </p>
                                                        <p>Student's Name: {{params.firstname}}, {{params.lastname}}</p>
                                                        <p>Student's Email: {{params.email}}</p>
                                                        <p>Student's Phone Number: {{params.phone}}</p>
                                                        
                                                        
                                                    </body></html>`,
          params: {
            course: emaildata.course,
            coursePrice: priceSplitter(emaildata?.coursePrice),
            paidPrice: priceSplitter(emaildata?.paidPrice),
            email: emaildata?.email,
            phone: emaildata?.phone,
            firstname: emaildata?.firstname,
            lastname: emaildata?.lastname,
            currencySymbol: emaildata?.paymentCurrency,
          },
          attachment: [
            {
              name: "Payment Receipt.pdf",
              content: base64Content,
            },
          ],
        };
      }


      const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
        process.env.REACT_APP_SERVICE_KEY, {
        method: "post",
        body: JSON.stringify({
          email: process.env.REACT_APP_SERVICE_EMAIL,
          password: process.env.REACT_APP_SERVICE_PASSWORD,
          returnSecureToken: true,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const userToken = await responseToken.json();
      await axios
      .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyEmailToAdmin, {
          headers: { Authorization: `Bearer ${userToken.idToken}` },
        }
      )
      .then()
      .catch((e) => {
        console.log("(axios) an error occurred sending mail", e)
      });
    },
    []
  );

  const CurrencyConvertion = async (
    baseCurrency: string,
    expectedCurrency: string,
    baseValue: number
  ): Promise<number | null> => {
    return await axios
      .get(
        `https://v6.exchangerate-api.com/v6/64ffa46158cccca95fdfa2db/pair/${baseCurrency}/${expectedCurrency}/${baseValue}`
      )
      .then((expectedValue) => {
        if (expectedValue.data.result === "success") {
          return expectedValue.data?.conversion_result;
        }
        if (expectedValue.data.result === "error") {
          return null;
        }
      });
  };

  const editReferralData = useCallback(
    async (
      coursepaidfor: string,
      email: string,
      coursecurrency: string,
      priceofcourse: number
    ) => {
      let CurrencyOfCourse = "NGN";
      if (coursecurrency === "€") {
        CurrencyOfCourse = "EUR";
      }
      if (coursecurrency === "$") {
        CurrencyOfCourse = "USD";
      }
     
      let idToken = await GetToken();

      const referrerResponse = await axios
        .get(`${baseUrl}/referrers`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .catch((error) => {
          console.log(error.response.data);
        });
      // console.log(referrerResponse);
      if (referrerResponse?.data) {
        let referrerObject: any;
        let listOfOtherReferrals: Referrals[] = [];
        let referrerToPatch: any;

        const ReferrerAccounts: Referrers[] = referrerResponse?.data || [];

        ReferrerAccounts.forEach((referrer: Referrers) => {
          if (referrer.Referrals) {
            referrer.Referrals.forEach((referrerDetails: Referrals) => {
              if (referrerDetails.Email === email) {
                referrerToPatch = referrerDetails;
                referrerObject = referrer; // Store the entire referrer object
              }
            });

            // Only if we found a match, collect other referrals under the same referrer
            if (referrerObject && referrer === referrerObject) {
              referrer.Referrals.forEach((referrerDetails: Referrals) => {
                if (referrerDetails !== referrerToPatch) {
                  listOfOtherReferrals.push(referrerDetails);
                }
              });
            }
          }
        });
        ///PATCH OPERATION
        if (referrerObject && referrerToPatch) {
          let referralRate = 0.1;
          if (
            referrerObject.ReferrerStatus === "Employee" ||
            referrerObject?.ReferrerStatus === "Admin"
          ) {
            referralRate = 0.15;
          }
          //console.log("You have a referrer and your data hasn't been updated yet")

          const profit =
            (await CurrencyConvertion(
              CurrencyOfCourse,
              referrerObject?.EarningsCurrency,
              priceofcourse * referralRate
            )) || 0;
          const bodyReferrals = {
            EarningsAccrued: referrerObject?.EarningsAccrued + profit,
            Referrals: [
              ...listOfOtherReferrals,
              {
                CoursePaidFor: coursepaidfor,
                CurrencyOfCoursePaidFor: CurrencyOfCourse,
                DateRegistered: format(
                  new Date(),
                  "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
                ),
                DateSignedUp: referrerToPatch.DateSignedUp,
                EarningsLabel: "Paid",
                Email: email,
                Name: referrerToPatch.Name,
                PriceOfCoursePaidFor: priceofcourse,
                ReferralStatus: "Converted",
              },
            ],
          };
          axios
            .patch(
              `${baseUrl}/referrers/` +
                referrerObject.Id,
              bodyReferrals,
              {
                headers: {
                  Authorization: `Bearer ${idToken}`,
                },
              }
            )
            .catch((error) => {
              console.log(error.response.data);
            });
        }
      }
    },
    []
  );

  const successaction = useCallback(async () => {
    if (track.current === 0) {
      track.current = 1;
      var body: any;
      let parsedObject: ParsedObject;
      if (sessionStorage.getItem("enroll-form-dataform")) {
        try {
          parsedObject = await processEnrollFormData(
            sessionStorage.getItem("enroll-form-dataform")
          );
          body = {
            DeadlineValue: parsedObject?.DeadlineValue,
            HasDeadline: parsedObject?.HasDeadline,
            course: parsedObject?.course.trim(),
            coursePrice: parsedObject?.coursePrice,
            email: parsedObject?.email.trim(),
            firstname: parsedObject?.firstname.trim(),
            lastname: parsedObject?.lastname.trim() || " ".trim(),
            paidPrice: parsedObject?.paidPrice,
            paymentCurrency: parsedObject?.paymentCurrency,
            paymentPercentage: parsedObject?.paymentPercentage,
            phone: parsedObject?.phone.trim(),
            sourceOfDiscovery: parsedObject?.sourceOfDiscovery,
            status: parsedObject?.status,
          };
          let idToken = await GetToken();
              if (parsedObject?.paymentType === "secondinstallment") {
                try {
                  await axios
                    .patch(
                      `${baseUrl}/course-registration/` +
                        parsedObject?.enrolledUserId,
                      body,
                      {
                        headers: {
                          Authorization: `Bearer ${idToken}`,
                        },
                      }
                    )
                    .then(() => {
                    });
                  if (parsedObject.Referred) {
                    editReferralData(
                      parsedObject.course.trim(),
                      parsedObject.email.trim(),
                      parsedObject.paymentCurrency.trim(),
                      parsedObject.AmountPaid
                    );
                  }
                } catch (error) {
                  console.log(
                    "Error patching user details in the course reg db",
                    error
                  );
                }
              } else {
                try {
                 await axios
                    .post(
                      `${baseUrl}/course-registration`,
                      body,
                      {
                        headers: {
                          Authorization: `Bearer ${idToken}`,
                        },
                      }
                    )
                    .then(() => {
                      // console.log(response2?.data?.data?.id);
                    });
                  if (parsedObject.Referred) {
                    editReferralData(
                      parsedObject.course.trim(),
                      parsedObject.email.trim(),
                      parsedObject.paymentCurrency.trim(),
                      parsedObject.AmountPaid
                    );
                  }
                } catch (error) {
                  console.log(
                    "Error creating user details in the course reg db",
                    error
                  );
                }
              }
              if(!courses){
                console.log("Courses does not exist")
                setCompletes(true);
                return;
              }
              var Courses:any = courses;
              const _course:any = Courses?.filter((each:any)=>each?.CourseName.toLowerCase() === parsedObject?.course.toLowerCase());
              sessionStorage.removeItem("enroll-form-dataform");
              sessionStorage.removeItem("sessiontrackidss");
              
              // Generate PDF receipt here
              let generatedReceipt = await generateReceipt(
                parsedObject?.firstname,
                parsedObject?.lastname,
                parsedObject?.email,
                parsedObject?.course,
                parsedObject?.paymentType,
                parsedObject?.paymentCurrency,
                parsedObject?.CourseDiscount,
                parsedObject?.paidPrice,
                parsedObject?.AmountCharged,
                parsedObject?.FullCoursePrice,
              );
              if(_course[0]){
                SendEmailToCustomer(
                body,
                _course[0],
                parsedObject.paymentType,
                generatedReceipt,
              );
              sendEmailtoAdmin(body, parsedObject.paymentType, generatedReceipt);
              }
              
              setCompletes(true);
              toast("Payment process completed");

              //CHANGE THEIR SCHOLARSHIP USED STATUS IF THEY ARE SCHOLARSHIP RECIPIENTS.
              if (parsedObject.scholarshipRecipient === true) {
                const bodyToUserObject = {
                  scholarshipUsed: true,
                };
                try {
                  await axios
                    .patch(
                      `${baseUrl}/registration/` +
                        parsedObject?.userId,
                      bodyToUserObject,
                      {
                        headers: {
                          Authorization: `Bearer ${idToken}`,
                        },
                      }
                    )
                    .then((response2) => {
                      console.log(response2?.data?.data?.id);
                    });
                } catch (error: any) {
                  // console.log("Cannot edit user object status");
                }
              }
              
              if(parsedObject.PromoCodeRecipient === true){
                try {
                  const body={} // I learnt a patch request needs to have a body, even if it's not needed.
                  await axios
                    .patch(
                      `${baseUrl}/promo/${parsedObject.inputedPromoCode}`,body,
                      {
                        headers: {
                          Authorization: `Bearer ${idToken}`,
                        },
                      }
                    ).then(() => {
                      console.log("Promo code recipient status updated successfully");
                    });
                } catch (error: any) {
                  console.log("Error updating promo code recipient status");
                }
              }
        } catch (error: any) {
          setCompletes(false);
          toast("Server error! Please contact admin!");
          console.log(error.message);
        }
      }else{
        toast("Payment confirmed. Information not saved. Please contact admin");
        console.log("User details storage failed!");
        setCompletes(true);
      }
    }
  }, [ sendEmailtoAdmin, SendEmailToCustomer, editReferralData, courses]);

  async function processEnrollFormData(data: any) {
    var retrievedObject: any = data;
    return await JSON.parse(retrievedObject);
  }

  useEffect(() => {
    const populateCourses = async ()=>{
      if(!courses){
        const value = await PopulateContext("Courses");
        const newValue = value.filter((each:any)=> each.isDeleted === false && each.isArchive === false)
        setCoursesContext(newValue);
      }
    }
    populateCourses()
    if(courses){
      successaction();
    }
  }, [courses, setCoursesContext, successaction]);

  return (
    <div>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      <Header />
      <ToastContainer autoClose={2000} />
      <div style={{ width: "100%", overflowX: "hidden", overflowY: "hidden" }}>
        <div className="text-center successenrollform">
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div
                style={{
                  backgroundColor: "#f5f8f8",
                  borderRadius: "10px",
                  paddingTop: "25px",
                  paddingBottom: "55px",
                }}
              >
                {completes ? (
                  <>
                    <div>
                      <img
                        src="../../images/Dollarsuccess.png"
                        alt="Payment successful"
                        style={{ paddingBottom: "30px", paddingLeft: "160px" }}
                      />
                      <h2>Payment Successful</h2>
                      <h5 style={{ color: "#696969" }}>
                        Thank you for your payment
                      </h5>
                      <button
                        className="btn btn-success"
                        onClick={handleGoBack}
                      >
                        Continue
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="academystyle">
                      <img
                        src="../../images/doyenifyAcademy.png"
                        alt="Doyenify academy"
                      />
                      </div>
                      <ClipLoader size={25} color="#047E35" />
                      <h2> Processing, please wait...</h2>
                  </>
                )}
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
};

export default EnrollFormSuccess;
